import { IApplicationState } from '../../types/redux';
import { hasValidPhone } from '../../utils/agent';

export function getBuilders(state: IApplicationState) {
  const {
    newbuildingInfo: { builders },
  } = state;

  if (builders) {
    return builders;
  }

  return [];
}

export function getBuildersWithValidPhones(state: IApplicationState) {
  return getBuilders(state).filter(hasValidPhone);
}
